/**
 * Site Tabs
 */

'use strict';

// Listen for alpine.js ready
document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'siteTabs', () => ({

		root: null,
		tabs: [],

		overview: false,

		portfolioOrganizations: false,

		impact: false,

		teamAdvisors: false,

		investors: false,

		newsInsights: false,

		init() {
			this.root = this.$refs.root;
			this.tabs = this.$el.querySelectorAll( '[data-tab]' );

			// Check if there's a tab in the URL hash on page load.
			const tabFromUrl = window.location.hash.replace( '#', '' );
			if ( tabFromUrl ) {
				this.activateTab( tabFromUrl );
			} else {
				// If the tab is empty, activate the overview tab.
				this.overview = true;
			}
		},

		activateTab( tab ) {

			// Find the visible tab.
			const visibleTab = this.root.querySelector( '.tab-content.is-visible' );
			if ( visibleTab ) {
				// Hide the visible tab.
				this[visibleTab.dataset.tab] = false;
			}

			// Show the new tab.
			this[tab] = true;

			// Update the URL hash.
			window.location.hash = tab;

			// Get the height of the #site-hero__main element if it exists, otherwise set to 0.
			const siteHeroMain = document.querySelector( '#site-hero' );

			let siteHeroMainHeight = 0;

			if ( siteHeroMain ) {
				siteHeroMainHeight = siteHeroMain.clientHeight;
			}

			// Get the height of the #wpadminbar element if it exists, otherwise set to 0.
			const siteAdminBar = document.querySelector( '#wpadminbar' );

			let siteAdminBarHeight = 0;

			if ( siteAdminBar ) {
				siteAdminBarHeight = siteAdminBar.clientHeight;
			}

			// Get the heigth of the #site-hero-subnav element if it exists, otherwise set to 0.
			const siteHeroSubnav = document.querySelector( '#site-hero-subnav' );

			let siteHeroSubnavHeight = 0;

			if ( siteHeroSubnav ) {
				siteHeroSubnavHeight = siteHeroSubnav.clientHeight;
			}

			// Calculate the scroll position with the height of existing elements.
			const siteTabOffsetTotal = siteHeroMainHeight + siteAdminBarHeight - siteHeroSubnavHeight;

			// Scroll to the calculated position.
			// console.log( 'Scrolling to offset:', siteTabOffsetTotal );
			window.scrollTo({ top: siteTabOffsetTotal, behavior: 'smooth' });
		}

	}) );
});